import type { PartnerRole } from '../auth/roles';

export type ProfileStatus = 'draft' | 'published';

/** Mirrors PartnerRole; stored denormalized on profiles for discovery. */
export type ProfileRoleType = PartnerRole;

export type ProfileFontStyle = 'sans' | 'serif' | 'mono';

export interface ProfileThemeConfig {
  templateId: string;
  primaryColor: string;
  backgroundColor: string | null;
  backgroundImageUrl: string | null;
  fontStyle: ProfileFontStyle;
  buttonRadius: number;
  buttonColor: string;
}

export interface Profile {
  id: string;
  ownerId: string;
  slug: string;
  title: string;
  description: string | null;
  tagline: string | null;
  location: string | null;
  avatarUrl: string | null;
  roleType: ProfileRoleType;
  tags: string[];
  status: ProfileStatus;
  themeConfig: ProfileThemeConfig;
  viewCount: number;
  createdAt: Date | null;
  updatedAt: Date | null;
}

export interface CreateProfileInput {
  /** Initial slug is claimed via Cloud Function after create; client creates with empty slug. */
  slug?: string;
  title: string;
  description?: string;
  tagline?: string | null;
  location?: string | null;
  avatarUrl?: string | null;
  /** Optional — application layer derives from identity.partnerRole when omitted. */
  roleType?: ProfileRoleType;
  tags?: string[];
  themeConfig?: Partial<ProfileThemeConfig>;
}

export interface UpdateProfileInput {
  slug?: string;
  title?: string;
  description?: string | null;
  tagline?: string | null;
  location?: string | null;
  avatarUrl?: string | null;
  roleType?: ProfileRoleType;
  tags?: string[];
  status?: ProfileStatus;
  themeConfig?: Partial<ProfileThemeConfig>;
}

export const DEFAULT_THEME_CONFIG: ProfileThemeConfig = {
  templateId: 'editoriale',
  primaryColor: '#6B7A5A',
  backgroundColor: null,
  backgroundImageUrl: null,
  fontStyle: 'sans',
  buttonRadius: 12,
  buttonColor: '#6B7A5A',
};
